export function resources( $ ) {
    $(document).ready(function(e) {
        const $resourceFilter = $('#resource-filter');

        hideSubmit($resourceFilter);

        initActions($resourceFilter);

    })


    function hideSubmit($resourceFilter) {
        $resourceFilter.find('input[type="submit').addClass('hidden');
    }

    function initActions($resourceFilter) {
        $resourceFilter.find('select').each(function(e) {
            $(this).on('change', function(e) {
                $resourceFilter.submit();
            })
        })

        $resourceFilter.on('submit', function(e) {
            e.preventDefault(); 
            $.ajax({
                url: $resourceFilter.attr('action'),
                data: $resourceFilter.serialize(),
                type: $resourceFilter.attr('method'),
                success: function(jsonData) {
                    const data = JSON.parse(jsonData);
                    const loadMoreBtn = document.querySelector('[data-action="load-more"]');
                    
                    // reset loadmore data
                    emc_loadmore_params.current_page = 1;
                    emc_loadmore_params.max_num_pages = data.max_num_pages;

                    // hide loadmore button if current page is last page
                    if( emc_loadmore_params.current_page >= emc_loadmore_params.max_num_pages ) {
                        loadMoreBtn.parentNode.classList.add('hidden');
                    } else {
                        loadMoreBtn.parentNode.classList.remove('hidden');
                    }

                    // output the data to the page
                    const resourcesContainer = $resourceFilter.data('result-container');
                    $('#' + resourcesContainer).empty().append(data.html);
                }

            })
        });
    }
}